import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Paper,
  Box,
  LinearProgress,
  Chip,
} from "@mui/material";
import { getCustomerLoanDetailService } from "../../../../services/loanService";
import useStore from "../../../../useStore";
import moment from "moment";

function CustomerLoanDetails() {
  const { loanId } = useStore();
  const [loanDetails, setLoanDetails] = useState({});

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await getCustomerLoanDetailService(loanId);
        console.log(response);
        setLoanDetails(response); // assuming the API returns the correct fields
      } catch (error) {
        console.error("Failed to fetch loan details:", error);
      }
    };

    fetchDetails();
  }, [loanId]);

  const calculateProgress = (progress) => {
    if (typeof progress !== "string" || !progress?.includes("/")) {
      console.error("Invalid progress format:", progress);
      return 0; // Default to 0% progress
    }

    const [paid, total] = progress?.split("/").map(Number);

    if (isNaN(paid) || isNaN(total) || total === 0) {
      console.error("Invalid progress values:", { paid, total });
      return 0; // Default to 0% progress
    }

    return (paid / total) * 100;
  };

  // Example usage

  return (
    <Paper
      elevation={3}
      sx={{
        padding: "20px",
        borderRadius: "12px",
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#3f51b5" }}
      >
        Loan Details
      </Typography> */}

      <Grid container spacing={3}>
        {[
          { label: "Loan Code", value: loanDetails?.loanCode },
          { label: "Loan Type", value: loanDetails?.loanType },
          { label: "Agent Name", value: loanDetails?.agent?.userName },
          { label: "Agent Code", value: loanDetails?.agent?.code },
          { label: "Frequency", value: loanDetails?.frequency },
          { label: "Loan Tenure ", value: loanDetails?.loanTenure },
          { label: "Loan Amount", value: `₹${loanDetails?.loanAmount}` },
          {
            label: "Total Loan Amount",
            value: `₹${loanDetails?.totalLoanAmount}`,
          },
          {
            label: "Interest Amount",
            value: `₹${loanDetails?.interestAmount}`,
          },
          { label: "Processing Fee", value: `₹${loanDetails?.processingFee}` },
          { label: "Insurance Fee", value: `₹${loanDetails?.insuranceFee}` },
          {
            label: "Disbursed Amount",
            value: `₹${loanDetails?.disbursedAmount}`,
          },
          {
            label: "Amount to be Paid By",
            value: loanDetails?.amountToBePaidBy,
          },

          { label: "Penalty Amount", value: `₹${loanDetails?.penaltyAmount}` },
          {
            label: "Start Date",
            value: moment(loanDetails?.startDate).format("DD-MM-YYYY"),
          },
          {
            label: "End Date",
            value: moment(loanDetails?.endDate).format("DD-MM-YYYY"),
          },
          { label: "Status", value: loanDetails?.status },
          {
            label: "Remaining Amount",
            value: `₹${loanDetails?.remainingAmount}`,
          },
          {
            label: "Total Received Amount",
            value: `₹${loanDetails?.totalReceivedAmount}`,
          },
          {
            label: "Total Interest Paid",
            value: `₹${loanDetails?.totalInterestAmountPaid}`,
          },
          {
            label: "Total Penalty Paid",
            value: `₹${loanDetails?.totalPenaltyAmountPaid}`,
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={3} key={index}>
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", color: "#555" }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#333", marginTop: "4px" }}
            >
              {item.label === "Status" ? (
                <Chip
                  label={item.value}
                  sx={{
                    bgcolor: item.value === "Active" ? "green" : "red",
                    color: "white",
                  }}
                />
              ) : (
                item.value || "N/A"
              )}
            </Typography>
          </Grid>
        ))}

        {/* Progress Bar for EMI */}
        <Grid item xs={12}>
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", color: "#555", marginBottom: "8px" }}
          >
            EMI Payment Progress
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <LinearProgress
              variant="determinate"
              value={calculateProgress(loanDetails.progress)}
              sx={{
                flex: 1,
                height: "8px",
                borderRadius: "5px",
                backgroundColor: "#ddd",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#4caf50", // Green progress bar
                },
              }}
            />
            <Typography
              variant="body2"
              sx={{ marginLeft: "10px", fontWeight: "bold" }}
            >
              {loanDetails.progress}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default CustomerLoanDetails;
